import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfileAvatarComponent } from './avatar.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ProfileAvatarComponent],
  exports: [ProfileAvatarComponent],
})
export class ProfileAvatarModule {}
